import { Icon, type IconName } from './Icon';

export type StatCardTone = 'brand' | 'amber' | 'info' | 'muted';

interface StatCardProps {
  label: string;
  value: number | string;
  tone?: StatCardTone;
  icon: IconName;
}

export function StatCard({ label, value, tone = 'muted', icon }: StatCardProps) {
  const bg =
    tone === 'brand'
      ? 'var(--brand-soft)'
      : tone === 'amber'
        ? 'var(--amber-soft, #fef3c7)'
        : tone === 'info'
          ? 'var(--info-soft, #dbeafe)'
          : 'var(--surface-2)';
  const color =
    tone === 'brand'
      ? 'var(--brand)'
      : tone === 'amber'
        ? 'var(--amber, #d97706)'
        : tone === 'info'
          ? 'var(--info, #2563eb)'
          : 'var(--text-3)';
  const display = typeof value === 'number' ? value.toLocaleString() : value;
  return (
    <div className="side-card" style={{ padding: 14, display: 'flex', alignItems: 'center', gap: 10 }}>
      <span
        style={{
          width: 30,
          height: 30,
          borderRadius: 7,
          background: bg,
          color,
          display: 'grid',
          placeItems: 'center',
        }}
      >
        <Icon name={icon} size={14} />
      </span>
      <div>
        <div style={{ fontSize: 11, color: 'var(--text-3)', textTransform: 'uppercase' }}>
          {label}
        </div>
        <div style={{ fontSize: 22, fontWeight: 600 }}>{display}</div>
      </div>
    </div>
  );
}
